var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.value)?_c('span',{staticClass:"info"},[_vm._v("V"+_vm._s(_vm.value))]):_c('span',[_vm._v("未定版")])])
}
var staticRenderFns = []

export { render, staticRenderFns }